/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Dialogue_SourceInputs */

const en_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue & Source`)
};

const fr_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue et source`)
};

const de_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog & Quelle`)
};

const it_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogo e fonte`)
};

const ru_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диалог и Источник`)
};

const es_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo y fuente`)
};

const zh_cn2_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话与来源`)
};

const ja_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対話と情報源`)
};

const hi_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद और स्रोत`)
};

const pt_pt2_ad_section_dialogue_source = /** @type {(inputs: Ad_Section_Dialogue_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo e Fonte`)
};

/**
* | output |
* | --- |
* | "Dialogue & Source" |
*
* @param {Ad_Section_Dialogue_SourceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_dialogue_source = /** @type {((inputs?: Ad_Section_Dialogue_SourceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Dialogue_SourceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_section_dialogue_source(inputs)
	if (locale === "de") return de_ad_section_dialogue_source(inputs)
	if (locale === "it") return it_ad_section_dialogue_source(inputs)
	if (locale === "ru") return ru_ad_section_dialogue_source(inputs)
	if (locale === "es") return es_ad_section_dialogue_source(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_section_dialogue_source(inputs)
	if (locale === "ja") return ja_ad_section_dialogue_source(inputs)
	if (locale === "hi") return hi_ad_section_dialogue_source(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_section_dialogue_source(inputs)
	return en_ad_section_dialogue_source(inputs)
});